/**
 * @author Artem Lytvynov
 * @copyright Artem Lytvynov
 * @license Apache-2.0
 */

export enum JOIN_ATTRS_LIST {
  TYPE = "type",
  LEFT = "left",
  RIGHT = "right",
  DESCRIPTION = "description",
}
